import React from 'react';
import AttachmentContent from "./attachment-content.jsx";
import DisplacementContent from "./displacement-content.jsx";
import ImageReservationContent from "./image-reservation-content.jsx";
import ReportUtils from "../../../../../utils/report-utils.js";
import GarrisonFiscalizationContent from "./garrison-fiscalization-content.jsx";
import {buildAttachmentRows, GARRISON_FISCALIZATION_FIELD, isAttachmentField, isIgnoredInlineField, parseAuditJson} from "../utils/dispatch-audit-utils.js";

const UpdateContent = ({element}) => {
    const updateData = parseAuditJson(element?.diff);

    return (
        <tr className="update-content-table">
            <td colSpan={14} className={'bg-white!'}>
                <table className="applied insider w-full">

                    <thead>
                        <tr className='text-left'>
                            <th style={{width: "30%"}}>Campo</th>
                            <th style={{width: "35%"}}>Novo</th>
                            <th style={{width: "35%"}}>Antigo</th>
                        </tr>
                    </thead>

                    <tbody>

                    {Object.entries(updateData).map(([key, value], index) => {
                        if (isIgnoredInlineField(key)) return null;

                        if (isAttachmentField(key)) {
                            const attachments = buildAttachmentRows(value);
                            if (attachments.length === 0) return null;

                            return (
                                <AttachmentContent key={key} attachments={attachments} isUpdate/>
                            );
                        }

                        let label = key;
                        if (key.trim() === "attendance_lastuser") {
                            label = "Usuário que realizou alteração";
                        }

                        return (
                            <tr key={key} className="text-left">
                                <td>{label}</td>
                                <td className={'break-all! whitespace-normal'}>{ReportUtils.formatObjectString(value?.new) ?? ""}</td>
                                <td className={'break-all! whitespace-normal'}>{ReportUtils.formatObjectString(value?.old) ?? ""}</td>
                            </tr>
                        );
                    })}

                    { updateData[GARRISON_FISCALIZATION_FIELD] && (
                        <GarrisonFiscalizationContent garrison={updateData[GARRISON_FISCALIZATION_FIELD]} isUpdate/>
                    )}

                    { updateData.dispatch_displacement && (
                        <DisplacementContent displacements={updateData.dispatch_displacement} isUpdate/>
                    )}

                    { updateData["image-reservation"] && (
                        <ImageReservationContent reservation={updateData["image-reservation"]} isUpdate/>
                    )}

                    </tbody>

                </table>
            </td>
        </tr>
    );
};

export default UpdateContent;